<template>
  <div>
    <div class="d-flex flex-column" v-for="(reason, index) in $t('Home.ReasonsHome')" :key="index">
      <div class="container-number">{{ reason.reasonNumber }}</div>
      <div class="container-reason">
        <div class="d-flex flex-column justify-center container-reason-content">
          <div v-html="reason.title"></div>
          <div class="mt-2">{{ reason.description }}</div>
        </div>

        <!-- interactive button on reason -->
        <div class="d-flex justify-center mt-3 mb-3">
          <v-btn
            rounded
            small
            class="font-weight-light text-capitalize btn-text"
            color="purple darken-4"
            @click="analyticSignUp"
            dark
          >
            <a
              href="/signup"
              class="white--text"
              style="font-family: Open Sans; text-decoration: none; font-size:12px;"
            >
              <span v-html="reason.advertising" />
            </a>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
export default {
  methods: {
    analyticSignUp() {
      firebase.analytics().logEvent("Sig_ReasonHome");
    },
  },
};
</script>

<style>
.container-number {
  position: absolute;
  background-color: #fff;
  left: calc(50% - 82px / 2);
  z-index: 99;
  height: 70px;
  width: 70px;
  border-radius: 70px;
  margin: 50px auto 0px;
  border: 1px solid #4a148c;
  text-align: center;
  padding: 5px;
  font-size: 40px;
  font-family: Open Sans;
  font-weight: bold;
  color: #4a148c;
}

.container-reason {
  width: 50%;
  height: 100%px;
  border: 1px solid #4a148c;
  margin: 90px auto 0px;
  border-radius: 40px;
}

.container-reason-content {
  font-family: Open Sans;
  text-align: center;
  margin: 50px 20px 0px 20px;
}

@media (max-width: 500px) {
  .phone-model {
    max-width: 90% !important;
  }

  .container-head {
    font-size: 20px !important;
    width: 85%;
  }

  .btn-text {
    font-size: 12px !important;
  }

  .container-number {
    height: 52px;
    width: 52px;
    border-radius: 52px;
    margin: 20px auto 0px;
    left: 42%;
    font-size: 28px;
  }

  .container-reason {
    width: 85%;
    height: 100%;
    border-radius: 30px;
    margin: 50px auto 0px;
  }

  .container-reason-content {
    text-align: center;
    margin: 30px 10px 0px 10px;
  }
}
</style>